export default __webpack_public_path__ + "static/offers-and-deflections-b64c9960e9117c385d8647b4834874a3.svg";